import { useContext, useMemo } from 'react';
import {
  getStateFromPath,
  getActionFromState,
} from '@react-navigation/native';
import * as Linking from 'expo-linking';

import { DeepLinkingContext } from '@context';
import { useLinking } from './useLinking';
import { screens } from '../navigation/screens';
import { getRouteNamesFromState } from '@utils';

export function useDeepLinking() {
  const deepLinking = useContext(DeepLinkingContext);
  const linking = useLinking();

  /**
   * On WEB we will not have preferredInitialUrl because preferredInitialUrl set
   * by push notifications or deep linking services, which we are not using on
   * WEB. Deep linking service value (redirect to WEB app) on WEB will be reachable
   * via Linking.getInitialURL
   */
  const preferredInitialUrl = useMemo(() => {
    if (deepLinking.openedUrl) {
      return deepLinking.openedUrl;
    } else if (deepLinking.initialUrl) {
      return deepLinking.initialUrl;
    } else {
      return null;
    }
  }, [deepLinking.openedUrl, deepLinking.initialUrl]);

  function getInitialAction() {
    if (preferredInitialUrl) {
      const { path } = Linking.parse(preferredInitialUrl);

      if (!path) {
        return null;
      }

      const state = getStateFromPath(path, linking.options?.config);

      if (!state) {
        return null;
      }

      const routeNames = getRouteNamesFromState(state);

      if (
        routeNames.includes(screens.AuthNavigator) ||
        routeNames.includes(screens.PaymentConfirm)
      ) {
        return null;
      }

      return getActionFromState(state, linking.options?.config);
    }

    return null;
  }

  return {
    ...deepLinking,
    getInitialAction,
    preferredInitialUrl,
  };
}
